import { ButtonLink } from './ButtonLink';
import { Section } from './Section';
import './HeroSection.css';

function EnterpriseDecisionGraphic() {
  return (
    <div className="enterprise-decision-graphic" aria-hidden="true">
      <span className="enterprise-decision-graphic__line enterprise-decision-graphic__line--one" />
      <span className="enterprise-decision-graphic__line enterprise-decision-graphic__line--two" />
      <span className="enterprise-decision-graphic__line enterprise-decision-graphic__line--three" />
      <span className="enterprise-decision-graphic__node enterprise-decision-graphic__node--one" />
      <span className="enterprise-decision-graphic__node enterprise-decision-graphic__node--two" />
      <span className="enterprise-decision-graphic__node enterprise-decision-graphic__node--three" />
      <span className="enterprise-decision-graphic__node enterprise-decision-graphic__node--four" />
      <span className="enterprise-decision-graphic__decision" />
    </div>
  );
}

export function HeroSection() {
  return (
    <Section id="hero" className="hero-section">
      <div className="hero-section__grid">
        <div className="hero-section__content">
          <h1>Enterprise intelligence for a changing seafood business</h1>
          <p className="hero-section__proposition">
            From fragmented enterprise information to coordinated decisions.
          </p>
          <div className="hero-section__body">
            <p>
              Seafood exporters operate across perishable inventory, global logistics, regulatory
              complexity, supply uncertainty, and changing demand.
            </p>
            <p>
              The platform continuously brings these dimensions together so the enterprise can
              understand what changed, evaluate what could happen next, and recommend the best
              coordinated action.
            </p>
          </div>
          <p className="hero-section__emphasis">
            <strong>Augment your existing ERP. Build a continuously intelligent enterprise.</strong>
          </p>
          <div className="hero-section__actions">
            <ButtonLink href="#solution">Explore the solution</ButtonLink>
            <ButtonLink href="#how-it-works" variant="secondary">
              See how it works
            </ButtonLink>
          </div>
        </div>
        <EnterpriseDecisionGraphic />
      </div>
    </Section>
  );
}
